import {
  Firstname,
  Lastname,
  Email,
  Phone,
} from '~/components/BaseForm/core/fields'
import { InputCheckbox } from '~/components/BaseForm/core/primitives'

import type { CoreGroupFields } from '~/components/BaseForm/types'

export default (): CoreGroupFields => {
  const firstname: typeof Firstname = {
    ...Firstname,
    attr: {
      ...Firstname.attr,
      labelTranslateKey: 'field.firstName',
      name: 'firstname',
      rules: 'required',
    },
    containerInputClass: 'w-full md:w-1/2 md:pr-2',
  }

  const lastname: typeof Lastname = {
    ...Lastname,
    attr: {
      ...Lastname.attr,
      labelTranslateKey: 'field.lastName',
      name: 'lastname',
      rules: 'required',
    },
    containerInputClass: 'w-full md:w-1/2 md:pl-2',
  }

  const email: typeof Email = {
    ...Email,
    attr: {
      ...Email.attr,
      labelTranslateKey: 'field.email',
      rules: 'required',
    },
    containerInputClass: 'w-full',
  }

  const phone: typeof Phone = {
    ...Phone,
    attr: {
      ...Phone.attr,
      labelTranslateKey: 'field.phone',
      rules: 'required',
    },
    containerInputClass: 'w-full',
  }

  const newsletter: typeof InputCheckbox = {
    ...InputCheckbox,
    attr: {
      ...InputCheckbox.attr,
      name: 'newsletter',
      labelTranslateKey: 'house.virtualVisit.newsletter',
      rules: '',
    },
    containerInputClass: 'w-full text-base',
  }

  return {
    containerGroupFieldsClass: 'flex flex-wrap',
    fields: [firstname, lastname, email, phone, newsletter],
  }
}
